import React from 'react'
import { Helmet } from 'react-helmet-async';

function MetaData(props) {

    const {pageTitle,metaDescription,metaKeywords,ogTitle,ogImage,ogDescription} = props.metaData;

    // console.log(pageTitle,metaDescription,metaKeywords,ogTitle,ogImage,ogDescription)

  return (
    <>
        <Helmet>
            <title>{pageTitle}</title>
            <meta name="description" content={metaDescription} />
            <meta name="keywords" content={metaKeywords} />
            <meta property="og:title" content={ogTitle} /> 
            <meta property="og:image" content={ogImage} />
            <meta property="og:description" content={ogDescription} />
        </Helmet>
    </>
  )
}

export default MetaData
